import { useSelector } from 'react-redux';
import {
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { PropsWithChildren } from 'react';
import { selectPatient } from '../../../redux/assessment';
import { MedicalDisclaimer } from './medical-disclaimer';
import { useLDFlags } from '../../providers/ld-flags';
import { getMedicalDisclaimerStates } from '../../../helpers/states';
import { AssessmentButtons, AssessmentCard } from '../shared';
import { Icon } from '../../icon/icon';

const ChecklistItem = ({ children }: PropsWithChildren<{}>) => (
  <ListItem disableGutters disablePadding alignItems="flex-start">
    <ListItemIcon sx={{ minWidth: 32 }}>
      <Icon icon="Check" color="success" fontSize="small" />
    </ListItemIcon>
    <ListItemText primary={children} />
  </ListItem>
);

const FinalChecklist = () => {
  const patient = useSelector(selectPatient);
  const { medicalDisclaimerStates } = useSelector(useLDFlags);
  const listOfMedicalDisclaimerStates: string[] = getMedicalDisclaimerStates(
    medicalDisclaimerStates
  );

  return (
    <>
      <AssessmentCard>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Your Talkiatry appointment checklist
        </Typography>
        <Typography>
          Thank you for trusting us with your care! There are a few simple steps
          to take before seeing your Talkiatry psychiatrist for the first time.
        </Typography>
        <List sx={{ py: 2 }}>
          <ChecklistItem>
            <>
              Before your first appointment, upload your <b>Insurance Card</b>
              &nbsp;(front & back) and <b>
                Driver's License/official State ID
              </b>{' '}
              using our&nbsp;
              <Link href="/document-upload" color="inherit">
                document uploader
              </Link>
              .
            </>
          </ChecklistItem>
          <ChecklistItem>
            <>
              Log in to the{' '}
              <Link
                href="https://mycw135.ecwcloud.com/portal18824/jsp/100mp/login_otp.jsp"
                color="inherit"
              >
                Patient Portal
              </Link>{' '}
              from your computer.
            </>
          </ChecklistItem>
          <ChecklistItem>
            <>
              Download the{' '}
              <Link href="https://healow.com/app.html" color="inherit">
                Healow application
              </Link>{' '}
              from your mobile device using facility code <b>FGCACD</b>.
            </>
          </ChecklistItem>
        </List>
        {listOfMedicalDisclaimerStates.includes(patient.addressState) && (
          <MedicalDisclaimer />
        )}
        <Typography variant="body2" color="GrayText">
          You may receive a confirmation call from our care coordination team
          which might appear as <b>Talkiatry Management Services</b> on your
          caller ID.
        </Typography>
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Return to Talkiatry.com',
          href: 'https://talkiatry.com',
          endIcon: undefined,
        }}
      />
    </>
  );
};

export default FinalChecklist;
